module.exports = __webpack_public_path__ + "static/img/kc2.6860860.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/kc2.png
// module id = WfLK
// module chunks = 1